module.exports = __webpack_public_path__ + "img/Haefele_menu6.b0f76817.png";